import React from "react";
import Index from "../_components/RoleManagement/Index";


function RoleManagementPage() {
    return <Index />
}

export default RoleManagementPage;